import { createAction } from 'redux-actions';

export const setTemplate = createAction('SET_TEMPLATE');